import React, { useState, useEffect } from "react";
import { SubmitRating, GetRating, ShowData } from "../Components/Services";
import Loading from "../../../../Common/Components/Loading";
import BoxShadow from "../../../../Common/Components/BoxShadow";

function Index() {
  const [state, setState] = useState({
    loading: true,
    data: null,
  });

  const handler = data => {
    SubmitRating(data).then(() => getData());
  };
  const getData = () => {
    setState({ loading: true });
    GetRating().then(data => {
      setState({ loading: false, data: data });
    });
  };

  useEffect(() => {
    getData();
  }, []);
  return (
    <div>
      <BoxShadow>
        <div className="card-body">
          <div className="h2">تنظیمات امتیاز دهی</div>
          {state.loading ? (
            <Loading count={1} col={12} height={300} />
          ) : (
            <TextInput
              form={[
                {
                  id: 1,
                  text: "مبنای محاسبه ی امتیاز در سفارش ها",
                  amount: "تومان",
                  value:
                    !state.loading && ShowData(state.data, "basedofscororder"),
                  key: "basedofscororder",
                },
                {
                  id: 2,
                  text: "تعداد امتیاز برای هر مبنا در سفارش ",
                  amount: "تعداد",
                  value: !state.loading && ShowData(state.data, "scorforbased"),
                  key: "scorforbased",
                },
                {
                  id: 3,
                  text: "تعداد امتیاز برای هر کامنت",
                  amount: "تعداد",
                  value: !state.loading && ShowData(state.data, "scorecomment"),
                  key: "scorecomment",
                },
                {
                  id: 4,
                  text: "تعداد امتیاز برای تکمیل پروفایل",
                  amount: "تعداد",
                  value:
                    !state.loading &&
                    ShowData(state.data, "scoreprofilecompelete"),
                  key: "scoreprofilecompelete",
                },
                {
                  id: 5,
                  text: "تعداد امتیاز برای  دعوت از دوستان",
                  amount: "تعداد",
                  value: !state.loading && ShowData(state.data, "scoreinvate"),
                  key: "scoreinvate",
                },
                {
                  id: 6,
                  text: "تعداد امتیاز برای ثبت نام در اپ",
                  amount: "تعداد",
                  value:
                    !state.loading && ShowData(state.data, "scoreappsingup"),
                  key: "scoreappsingup",
                },
              ]}
              method={handler}
            />
          )}
        </div>
      </BoxShadow>
    </div>
  );
}

export default Index;

const TextInput = ({ form, method }) => {
  const [state, setstate] = useState();
  const [elemnts, setElemnts] = useState([...form]);

  const handler = id => {
    let newElements = [...elemnts].map(item => {
      if (item.id == id) {
        item.edit = true;
        return item;
      } else {
      }
      return item;
    });
    setElemnts(newElements);
  };

  useEffect(() => {
    checkEmpty();
  }, []);

  const checkEmpty = () => {
    let newState = {};
    elemnts.map(element => {
      newState[element.key] = element.value;
    });
    setstate({ ...state, ...newState });
  };

  return (
    <div>
      {elemnts.map((element, key) => (
        <div
          key={key}
          className="d-flex p-2 my-3 rounded justify-content-between align-items-center shadow-sm"
        >
          <p className="p-0 align-self-center m-0">
            {element.text} <span>({element.amount})</span>
          </p>

          <div className="d-flex justify-content-center align-items-center ">
            <button
              className={`btn ${
                !element.edit ? "btn-primary" : "btn-success"
              } mx-1 d-flex align-items-center justify-content-center`}
              onClick={() => handler(element.id)}
            >
              <i className="fas fa-edit"></i>
            </button>
            <input
              type="text"
              dir="ltr"
              className="form-control"
              defaultValue={element.value ? element.value : ""}
              disabled={!element.edit}
              onChange={({ target: { value } }) => {
                setstate({ ...state, [element.key]: value });
              }}
            />
          </div>
        </div>
      ))}
      <div className="d-flex align-items-center justify-content-end mt-3">
        <button className="btn btn-primary" onClick={() => method(state)}>
          ارسال اطلاعات
        </button>
      </div>
    </div>
  );
};
